import store from '@/store'

const STORAGE_KEY = 'userStorage'

const LOCAL_STORAGE = window.localStorage
const STORAGE = window.sessionStorage

function getUserStorageKey () {
  return `${STORAGE_KEY}_${store.getters.user.id}`
}

function getUserStorage () {
  const userStorageKey = getUserStorageKey()
  return JSON.parse(STORAGE.getItem(userStorageKey)) || {}
}

/** key: nullable */
export function getUserData (key) {
  if (STORAGE) {
    return key ? getUserStorage()[key] : getUserStorage()
  }
  return null
}

/** key may be used as object (value in this case is not used) */
export function setUserData (key, value) {
  if (STORAGE) {
    const obj = {}
    if (typeof key === 'string') {
      obj[key] = value
    } else {
      Object.assign(obj, key)
    }
    let userStorage = getUserStorage()
    const userStorageKey = getUserStorageKey()

    Object.keys(obj).forEach(key => {
      const value = obj[key]
      if (value !== null) {
        userStorage[key] = value
      } else {
        delete userStorage[key]
      }
    })
    STORAGE.setItem(userStorageKey, JSON.stringify(userStorage))
  }
}

export default { getUserData, setUserData }



// WEBPACK FOOTER //
// ./src/utils/userStorage.js